import React, { useEffect, useState, useRef } from 'react';

const HoldTooltip = ({ tooltipContent,...parameters}) => {
    const [isHolding, setIsHolding] = useState(false);
    const timerId = useRef(null);
    const tooltipRef = useRef(null);

    useEffect(() => {
        window.document.addEventListener("mousedown", () => {
            if (tooltipRef && tooltipRef.current) {
                const holdTooltips = window.document.getElementsByClassName("holdTooltip");
                if (holdTooltips && holdTooltips.length > 0) {
                    for (var i = 0; i < holdTooltips.length; i++) {
                        holdTooltips[i].style.display = "none";
                    }
                }
            }
        });
    }, []);

    const handleMouseDown = (e) => {
        setIsHolding(true);
        timerId.current = setTimeout(() => {
            setIsHolding(false);

            if (tooltipRef && tooltipRef.current) {
                tooltipRef.current.style.display = "inline-block";
            }

            //const tooltip = window.document.getElementById(parameters.children[0].props.id);
            //if (tooltip) {
            //    tooltip.style.display = "inline-block";
            //}
        }, 500);
    };

    const handleMouseUp = () => {
        try {
            if (isHolding && parameters.onClick()) {
                parameters.onClick();
            }
        } catch (e) {

        }
        
        setIsHolding(false);
        clearTimeout(timerId.current);
    };

    const handleMouseLeave = () => {
        setIsHolding(false);
        clearTimeout(timerId.current);
    }

    return (
        <span
            style={parameters.sx}
            className={parameters.className}
            onTouchStart={handleMouseDown}
            onTouchEnd={handleMouseUp}
            onTouchCancel={handleMouseLeave}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
        >
            <div
                ref={tooltipRef}
                className="holdTooltip"
                style={{
                    display: "none"
                }}
            >
                {tooltipContent ?? tooltipContent}
            </div>
            {parameters.children}
        </span>
    );
}

export default HoldTooltip;